var _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 403.736 400",
    style: {
      enableBackground: "new 0 0 403.736 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.293 8h384v384h-384z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#b)",
      fill: "#bd88ec"
    },
    d: "m264.414 264.117 36.438-55.211-36.438-9.386c-4.773-14.321-12.887-27.844-24.344-39.301-11.297-11.297-24.66-19.571-39.3-24.344l-.477.477-44.391-1.75-19.73 1.273c-14.637 4.773-28.004 13.047-39.301 24.344l-58.984 58.984c-39.461 39.461-39.461 103.59 0 143.051 40.574 40.574 104.695 38.504 143.199 0l58.984-58.836c11.457-11.457 19.571-24.98 24.344-39.301zm-123.105 58.36c-17.821 17.82-46.301 17.343-63.645 0-17.5-17.504-17.5-46.145 0-63.645l58.508-58.359 31.98 31.664 32.141 31.504-58.984 58.836zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#b)",
      fill: "#be94ea"
    },
    d: "m240.07 303.418-58.984 58.836c-38.504 38.504-102.625 40.57-143.199 0l39.777-39.777c17.344 17.343 45.824 17.82 63.645 0l58.984-58.836-32.141-31.504 71.918-71.918c11.457 11.457 19.571 24.98 24.344 39.301l36.438 9.386-36.438 55.211c-4.773 14.321-12.887 27.844-24.344 39.301zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "m319.625 335.242-15.91-15.914c-4.399-4.394-4.399-11.512 0-15.91 4.398-4.395 11.512-4.398 15.91 0l15.91 15.91a11.245 11.245 0 0 1 0 15.914c-4.394 4.395-11.512 4.395-15.91 0zM80.961 96.574l-15.914-15.91a11.247 11.247 0 0 1 0-15.91c4.398-4.395 11.516-4.399 15.91 0l15.914 15.91c4.395 4.398 4.395 11.516 0 15.91-4.398 4.399-11.516 4.399-15.91 0zm260.605 141.274c1.606-6.004 7.778-9.563 13.782-7.957l21.738 5.828c6.004 1.578 9.547 7.777 7.957 13.781-1.609 6.008-7.777 9.566-13.785 7.957l-21.738-5.828c-5.965-1.594-9.563-7.738-7.954-13.781zM15.543 150.492c1.609-6.004 7.777-9.562 13.785-7.957l21.738 5.828c5.981 1.571 9.555 7.77 7.954 13.782-1.606 6.007-7.778 9.566-13.782 7.957L23.5 164.273c-5.965-1.593-9.566-7.738-7.957-13.781zm220.473 226.297-5.828-21.738c-1.61-6.004 1.949-12.172 7.957-13.781a11.232 11.232 0 0 1 13.781 7.957l5.828 21.738c1.605 6.004-1.953 12.172-7.957 13.781-6.039 1.609-12.184-1.992-13.781-7.957zm0 0"
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M8.293 8h384v384h-384z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#d)",
      fill: "#bd88ec"
    },
    d: "m148.66 50.77-5.828-21.739c-1.609-6.004 1.949-12.172 7.957-13.781 6.004-1.594 12.18 1.926 13.781 7.957l5.828 21.738c1.606 6.004-1.953 12.172-7.957 13.782-6.039 1.605-12.183-1.993-13.781-7.957zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#d)",
      fill: "#be94ea"
    },
    d: "M362.699 37.742c-39.461-39.461-103.582-39.621-143.199 0l-58.984 58.832c-11.457 11.457-19.571 24.981-24.344 39.301a101.937 101.937 0 0 0 0 64.602c4.773 14.316 12.887 27.843 24.344 39.3 11.136 11.137 24.504 19.411 39.3 24.34l.477-.476c17.504-17.5 17.5-46.141 0-63.645-17.504-17.5-17.504-46.141 0-63.644l58.984-58.832c8.594-8.594 19.731-13.047 31.825-13.047.316-.317 3.019-.161 3.656.16 8.594-.004 19.89 4.613 28.164 12.887 17.5 17.5 17.5 46.14 0 63.644l-58.508 58.356a101.921 101.921 0 0 1 0 64.597c14.481-4.929 28.164-13.203 39.301-24.344l58.984-58.832c39.461-39.461 39.457-103.742 0-143.199zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#d)",
      fill: "#bd88ec"
    },
    d: "m200.293 263.641-.477.476c-14.796-4.933-28.164-13.203-39.3-24.344l39.777-39.777c17.504 17.504 17.504 46.141 0 63.645zm162.406-82.7-58.984 58.836c-11.141 11.137-24.824 19.411-39.301 24.344 7-21.004 7-43.598 0-64.601l58.504-58.356c17.504-17.504 17.504-46.141 0-63.644l39.777-39.778c39.461 39.457 39.465 103.738.004 143.199zm0 0"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainIcon);
export default __webpack_public_path__ + "static/media/chainIcon.50ce0044c10c6071bae788006a920e95.svg";
export { ForwardRef as ReactComponent };